module.exports = __webpack_public_path__ + "img/home-btn-support.d5961110.svg";